<div class="validation-container" *ngIf="status && message">
  <div
    class="validation-box"
    [ngClass]="{
      success: status === 'success',
      error: status === 'error'
    }"
  >
    <h2 *ngIf="status === 'success'">✅ Email Validated Successfully</h2>
    <h2 *ngIf="status === 'error'">❌ Email Validation Failed</h2>

    <p>{{ message }}</p>
  </div>
</div>

<div class="validation-container" *ngIf="!status">
  <div class="validation-box neutral">
    <h2>Processing your request...</h2>
  </div>
</div>
